import type { SVGProps } from "react";

export type IconProps = SVGProps<SVGSVGElement>;

export function ColumnsIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <path d="M9 3v18M15 3v18" />
    </svg>
  );
}

export function SearchIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" {...props}>
      <circle cx="8.75" cy="8.75" r="5.25" />
      <path d="m12.75 12.75 3.75 3.75" />
    </svg>
  );
}

export function PlusIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" {...props}>
      <path d="M10 4v12M4 10h12" />
    </svg>
  );
}

export function TrashIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" {...props}>
      <path d="M4.5 6.25h11M8 3.75h4M6.25 6.25l.65 10h6.2l.65-10M8.5 9v4.5M11.5 9v4.5" />
    </svg>
  );
}

export function CopyIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" {...props}>
      <rect x="6.5" y="6.5" width="9" height="9" rx="1.5" />
      <path d="M13.5 6.5V5A1.5 1.5 0 0 0 12 3.5H5A1.5 1.5 0 0 0 3.5 5v7A1.5 1.5 0 0 0 5 13.5h1.5" />
    </svg>
  );
}

export function CheckIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" {...props}>
      <path d="m4.5 10.25 3.25 3.25 7.75-7.75" />
    </svg>
  );
}

export function ChevronDownIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" {...props}>
      <path d="m5.5 7.75 4.5 4.5 4.5-4.5" />
    </svg>
  );
}

export function ChevronRightIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true" {...props}>
      <path d="m6 3.5 4.5 4.5L6 12.5" />
    </svg>
  );
}

export function CloseIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" {...props}>
      <path d="m5.25 5.25 9.5 9.5m0-9.5-9.5 9.5" />
    </svg>
  );
}

export function MoreHorizontalIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" {...props}>
      <circle cx="4.25" cy="10" r="0.75" fill="currentColor" stroke="none" />
      <circle cx="10" cy="10" r="0.75" fill="currentColor" stroke="none" />
      <circle cx="15.75" cy="10" r="0.75" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function PencilIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" {...props}>
      <path d="m4 14.75.5-3 7.9-7.9a1.4 1.4 0 0 1 2 0l1.75 1.75a1.4 1.4 0 0 1 0 2l-7.9 7.9-3 .5Z" />
      <path d="m11.25 5 3.75 3.75M4.5 11.75l3.75 3.75" />
    </svg>
  );
}

export function DownloadIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" {...props}>
      <path d="M10 2.75v9.5m-3.5-3.5 3.5 3.5 3.5-3.5M3.25 14v1.25a2 2 0 0 0 2 2h9.5a2 2 0 0 0 2-2V14" />
    </svg>
  );
}

export function RefreshIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" {...props}>
      <path d="M15.75 6.75A6.25 6.25 0 1 0 16 12m-.25-5.25V3.5m0 3.25H12.5" />
    </svg>
  );
}

export function PlayIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" {...props}>
      <path d="m7 5 7.5 5L7 15Z" />
    </svg>
  );
}

export function StopIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" {...props}>
      <rect x="6" y="6" width="8" height="8" rx="1.5" />
    </svg>
  );
}

export function ArrowUpIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" {...props}>
      <path d="m5 11 5-5 5 5M10 6v9" />
    </svg>
  );
}

export function ImageIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" {...props}>
      <rect x="3.25" y="4" width="13.5" height="12" rx="2" />
      <circle cx="7.25" cy="8" r="1.25" />
      <path d="m4.5 14 3.75-3.75 2.5 2.5 1.75-1.75 3 3" />
    </svg>
  );
}

export function LogsIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 18 18" aria-hidden="true" {...props}>
      <path d="M5.5 4.5h8m-8 4.5h8m-8 4.5h5" />
      <circle cx="2.75" cy="4.5" r=".75" />
      <circle cx="2.75" cy="9" r=".75" />
      <circle cx="2.75" cy="13.5" r=".75" />
    </svg>
  );
}

export function DebuggerIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" {...props}>
      <path d="M7 7.25h6v5.5a3 3 0 0 1-6 0v-5.5Z" />
      <path d="M8.25 7.25V5.5a1.75 1.75 0 0 1 3.5 0v1.75M4.5 9.25H7m6 0h2.5M4.5 12.25H7m6 0h2.5M6 16l1.75-1.75M14 16l-1.75-1.75" />
    </svg>
  );
}

export function ReferenceIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" {...props}>
      <path d="M7.5 4.25H6.25A1.25 1.25 0 0 0 5 5.5v2.25A1.25 1.25 0 0 1 3.75 9H3v2h.75A1.25 1.25 0 0 1 5 12.25v2.25a1.25 1.25 0 0 0 1.25 1.25H7.5M12.5 4.25h1.25A1.25 1.25 0 0 1 15 5.5v2.25A1.25 1.25 0 0 0 16.25 9H17v2h-.75A1.25 1.25 0 0 0 15 12.25v2.25a1.25 1.25 0 0 1-1.25 1.25H12.5" />
    </svg>
  );
}

export function LogoutIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" {...props}>
      <path d="M8.25 4H5.5a1.5 1.5 0 0 0-1.5 1.5v9A1.5 1.5 0 0 0 5.5 16h2.75M12.25 6.5 15.75 10l-3.5 3.5M15.25 10H8" />
    </svg>
  );
}

export function ErrorIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <path d="M12 8v5m0 3.25v.25M10.3 4.7 3.1 17.2a2 2 0 0 0 1.74 3h14.32a2 2 0 0 0 1.74-3L13.7 4.7a2 2 0 0 0-3.4 0Z" />
    </svg>
  );
}

export function EmptyTasksIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <rect x="4" y="4" width="16" height="16" rx="3" />
      <path d="m8 10 1.5 1.5L12 9m2 2h2M8 16h8" />
    </svg>
  );
}

const navigationIconProps = {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": true,
} as const;

export function TasksIcon(props: IconProps) {
  return (
    <svg {...navigationIconProps} {...props}>
      <rect x="3" y="3" width="14" height="14" rx="2.5" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="m6.25 8 1.25 1.25L10 6.75M11.75 8h2M6.25 13h7.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function StrategiesIcon(props: IconProps) {
  return (
    <svg {...navigationIconProps} {...props}>
      <path d="M3 16.75V3.25M3 16.75h14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="m5.5 13 3-3 2.25 1.75L15.5 6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="15.5" cy="6" r="1.25" fill="currentColor" />
    </svg>
  );
}

function SidebarFrame() {
  return (
    <>
      <rect x="2.75" y="3.25" width="14.5" height="13.5" rx="2" stroke="currentColor" strokeWidth="1.5" />
      <path d="M7.25 3.75v12.5" stroke="currentColor" strokeWidth="1.5" />
    </>
  );
}

export function CollapseSidebarIcon(props: IconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" {...props}>
      <SidebarFrame />
      <path d="m13.5 7.5-2.5 2.5 2.5 2.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function ExpandSidebarIcon(props: IconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" {...props}>
      <SidebarFrame />
      <path d="m11 7.5 2.5 2.5-2.5 2.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
